import React from 'react';
import { useSelector } from 'react-redux';
import GeneralPageLayout from '../../components/layout/GeneralPageLayout';
import { selectCurrentFlow } from '../../store/slices/flow/flowSelectors';
import { useCloseWindow } from '../../hooks/useCloseWindow';

/**
 * This components is meant to be a generic message to display to the user no matter if the payment
 * is successful or has errored. This is required in some payment providers such as
 * xpressbillpay where there's no wayh to handle errors and redirect the user to a more
 * appropiate error page.
 */
const PaymentError = () => {
  const currentFlow = useSelector(selectCurrentFlow);
  const { isAbleToCloseWindow, closeWindow } = useCloseWindow();

  return (
    <GeneralPageLayout
      flow={currentFlow}
      next="Close Window"
      showNext={isAbleToCloseWindow}
      onNext={closeWindow}
    >
      <p>
        Please close this window, press the "Back" button on the previous window
        and then press the "Pay" button to start the payment process again.
      </p>
      <p>
        When prompted, you must hit "I Accept" to continue with the payment
        process.
      </p>
    </GeneralPageLayout>
  );
};

export default PaymentError;
